import Vue from 'vue';

const global = {
  namespaced: true,
  state: {
    data: {},
  },
  actions: {
    addState({ state }, { key, value }) {
      Vue.set(state.data, key, value);
    },
  },
};

export default global;
